import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../../Context/GlobalContext";
import ClipLoader from "react-spinners/ClipLoader";
import Cookies from "js-cookie";

const UpdateBranch = () => {
  const { baseUrl, openToast, branchItem, fetchBranch } = useGlobalContext();
  const navigate = useNavigate();
  const [branchName, setBranchName] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [loadingBranch, setLoadingBranch] = useState(false);

  // Set initial branch name when component loads
  useEffect(() => {
    if (branchItem?.branchName) {
      setBranchName(branchItem.branchName);
    }
  }, [branchItem]);

  // Update Branch Details
  async function updateBranchDetails() {
    try {
      setIsLoading(true);
      const result = await fetch(`${baseUrl}branch/${branchItem?.id}`, {
        method: "PUT",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({ branchName }),
      });

      if (result.status === 200) {
        openToast("Branch Name Updated Successfully", "success");
        navigate("/branch-details");
        fetchBranch();
      } else {
        openToast("Something went wrong", "error");
      }
    } catch (error) {
      openToast("Something went wrong", "error");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchBranch();
  }, []);

  return (
    <div className="bg-white mb-3 px-5 py-6 pr-2 pb-4 pl-[10px] w-[100%] addnewrole">
      <h2 className="font-medium text-[#27004a] text-[18px]">
        Update Branch Name
      </h2>

      {loadingBranch ? (
        <ClipLoader size={30} color="#7526d1" />
      ) : (
        <div className="w-[100%]">
          <div className="bg-[#fff] set-shadow mt-2 p-3 rounded-md w-[100%] md:w-[80%] lg:w-[50%] xl:w-[50%]">
            <label>Branch Name</label>
            <br />
            <input
              value={branchName} // <-- Ensuring the value updates properly
              type="text"
              onChange={(e) => setBranchName(e.target.value)}
              className="border-1 mt-2 pr-7 pl-3 border rounded-md w-[100%] h-[43px] text-[#aeabab] text-[15px] focus:outline-none"
            />

            <div className="flex justify-end gap-[10px] mt-3 text-end">
              <Link
                to="/branch-details"
                className="flex items-center hover:bg-[#7526d1] py-2 pt-2 pr-5 pl-5 rounded-md text-white first-btn"
              >
                Cancel
              </Link>
              <button
                className={`second-btn pt-2 py-2 pl-5 pr-5 rounded-md text-white hover:bg-[#7526d1] 
                              ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                onClick={updateBranchDetails}
                disabled={isLoading}
              >
                {isLoading ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateBranch;
